// src/components/TopBar.jsx
import React from "react";
import { Menu as MenuIcon } from "lucide-react";
import appLogo from "../assets/logo.png";
import NotificationBell from "./NotificationBell";

const SIDEBAR_WIDTH = 240;

export default function TopBar({
  organizationLogo,
  topbarLeft,
  topbarCenter,
  topbarRight,
  topbarHeight = 44,
  onOpenMobileNav,
}) {
  const logoSrc = organizationLogo || appLogo;

  return (
    <>
      {/* Desktop Top Bar (global) */}
      <div
        className="hidden md:flex fixed top-0 right-0 z-[1000] items-center justify-between px-4"
        style={{
          height: topbarHeight,
          left: SIDEBAR_WIDTH,
          background: "white",
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
        }}
      >
        <div className="min-w-0 flex-1 flex items-center gap-3 h-full">
          {topbarLeft ? topbarLeft : null}
          {topbarCenter ? (
            <div className="min-w-0 h-full flex items-center">
              {topbarCenter}
            </div>
          ) : null}
        </div>

        <div className="flex items-center justify-end gap-3">
          {topbarRight ? topbarRight : null}
          <NotificationBell />
        </div>
      </div>

      {/* Mobile Top Bar (SafetyCulture-style) */}
      <div
        className="fixed top-0 left-0 right-0 z-50 md:hidden flex items-center justify-between px-3 bg-white/90 backdrop-blur"
        style={{ height: 40, borderBottom: "1px solid #e5e7eb" }}
      >
        <button
          className="p-0 bg-transparent shadow-none rounded-none"
          onClick={onOpenMobileNav}
          style={{ border: "none" }}
          aria-label="Open navigation"
          type="button"
        >
          <MenuIcon size={26} />
        </button>

        <div className="flex items-center justify-center flex-1">
          <img
            src={logoSrc}
            alt="Logo"
            className="h-9 object-contain"
            style={{ maxWidth: 180 }}
          />
        </div>

        <div className="flex items-center justify-end w-[44px]">
          <NotificationBell />
        </div>
      </div>
    </>
  );
}
